/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * データ認証（内容タグに紐付いている拡張属性）されていない拡張属性定義をレスポンスに含めるかどうかを判断するためのフラグ - INCLUDE:含む - EXCLUDE:含まない 
 * @export
 * @enum {string}
 */

export const NotDataAuthorizationQuery = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE'
} as const;

export type NotDataAuthorizationQuery = typeof NotDataAuthorizationQuery[keyof typeof NotDataAuthorizationQuery];



